module.exports = __webpack_public_path__ + "static/media/login.655482f8.svg";